import { render, staticRenderFns } from "./ShowTask.vue?vue&type=template&id=88e74b70&scoped=true&"
import script from "./ShowTask.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ShowTask.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ShowTask.vue?vue&type=style&index=0&id=88e74b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e74b70",
  null
  
)

export default component.exports